import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Warn"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.98039 2.85547C6.03564 2.85547 2.83789 6.0533 2.83789 9.99797C2.83789 13.9426 6.03572 17.1405 9.98039 17.1405C13.9251 17.1405 17.1229 13.9426 17.1229 9.99797C17.1229 6.0533 13.9251 2.85547 9.98039 2.85547ZM9.38493 6.42671C9.38493 6.09803 9.65117 5.83149 9.98015 5.83149C10.3091 5.83149 10.5753 6.09803 10.5753 6.42671V10.6592C10.5753 10.9878 10.3091 11.2544 9.98015 11.2544C9.65117 11.2544 9.38493 10.9878 9.38493 10.6592V6.42671ZM9.98039 13.5692C9.5182 13.5692 9.14354 13.1946 9.14354 12.7324C9.14354 12.2702 9.5182 11.8956 9.98039 11.8956C10.4426 11.8956 10.8172 12.2702 10.8172 12.7324C10.8172 13.1945 10.4426 13.5692 9.98039 13.5692Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var warn = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { warn as default };
